module.exports = __webpack_public_path__ + "img/2-1_11.f6ba7639.jpg";